import { useFeatureFlagStore } from './useFeatureFlagStore'

/**
 * useFeatureFlag(name) -> boolean
 *
 * Returns true iff the named flag evaluated to true for the current user
 * during the most recent /api/flags fetch. Returns false while loading,
 * on fetch error, and for any name not in the response (typos and absent
 * flags are indistinguishable in this hook by design — fail-safe-to-false).
 *
 * Naming note: this is intentionally distinct from `useFlag` in
 * services/web/src/components/FlagContextMenu.jsx (the right-click word-flag
 * context menu, unrelated to feature flags).
 */
export function useFeatureFlag(name) {
  return useFeatureFlagStore((s) => s.flagMap[name] === true)
}
